import React from "react";
import { Box, Typography } from "@mui/material";
import { SpecsInputField } from "./SpecsEditorFields/index";
import { BooleanField, DisplayMethodField } from "./SpecsLayerSpecsControls";
import SpecsNumberField from "./specsForm/SpecsNumberField";
import type { LayerModel } from "./specsModel/LayerModel";

export function SpecsLayerSpecsLayerFields({
  layer,
  debugPath,
}: {
  layer: LayerModel;
  debugPath?: string;
}) {
  return (
    <Box>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Layer
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: 2,
        }}
      >
        <SpecsInputField
          label="Name"
          debugPath={debugPath ? `${debugPath}.name` : undefined}
          value={layer.name}
          onChange={(event) => {
            layer.name = event.target.value;
          }}
        />
        <SpecsInputField
          label="Layer label"
          debugPath={debugPath ? `${debugPath}.layerLabel` : undefined}
          value={layer.layerLabel}
          onChange={(event) => {
            layer.layerLabel = event.target.value;
          }}
        />
        <SpecsNumberField
          label="Credits"
          value={layer.credits}
          debugPath={debugPath ? `${debugPath}.credits` : undefined}
          onChange={(value) => {
            layer.credits = value ?? 0;
          }}
        />
        <DisplayMethodField
          label="Display method"
          debugPath={debugPath ? `${debugPath}.displayMethod` : undefined}
          value={layer.displayMethod}
          onChange={(value) => {
            layer.displayMethod = value;
          }}
        />
        <SpecsInputField
          label="Display group"
          debugPath={debugPath ? `${debugPath}.displayGroup` : undefined}
          value={layer.displayGroup}
          onChange={(event) => {
            layer.displayGroup = event.target.value;
          }}
        />
        <SpecsInputField
          label="Line highlight color"
          debugPath={debugPath ? `${debugPath}.lineHighlightColor` : undefined}
          value={layer.lineHighlightColor}
          onChange={(event) => {
            layer.lineHighlightColor = event.target.value;
          }}
        />
        <BooleanField
          label="Required"
          debugPath={debugPath ? `${debugPath}.required` : undefined}
          checked={layer.required}
          onChange={(checked) => {
            layer.required = checked;
          }}
        />
        <BooleanField
          label="Exclude from color count"
          debugPath={
            debugPath ? `${debugPath}.excludeFromColorCount` : undefined
          }
          checked={layer.excludeFromColorCount}
          onChange={(checked) => {
            layer.excludeFromColorCount = checked;
          }}
        />
        <BooleanField
          label="Immune to fabric overwrite by decoration"
          debugPath={
            debugPath
              ? `${debugPath}.immuneToFabricOverwriteByDecoration`
              : undefined
          }
          checked={layer.immuneToFabricOverwriteByDecoration}
          onChange={(checked) => {
            layer.immuneToFabricOverwriteByDecoration = checked;
          }}
        />
        <BooleanField
          label="Exclude from color bleed"
          debugPath={
            debugPath ? `${debugPath}.excludeFromColorBleed` : undefined
          }
          checked={layer.excludeFromColorBleed}
          onChange={(checked) => {
            layer.excludeFromColorBleed = checked;
          }}
        />
      </Box>
    </Box>
  );
}
